{
  "header": {
    "id": "ID",
    "firstname": "Nombre",
    "lastname": "Apellidos",
    "profile": "Perfil",
    "profiles": "Perfiles",
    "email": "E-mail",
    "description": "Descripción",
    "sector": "Red",
    "sectors": "Sectores",
    "group": "Grupo",
    "groups": "Grupos",
    "user": "Usuario",
    "users": "Usuarios",
    "application": "Aplicación",
    "applications": "Aplicaciones",
    "equipment": "Equipo",
    "equipments": "Equipos",
    "label": "Apellidos",
    "nbUsers": "Número de usuarios",
    "userGroup": "Grupo",
    "userGroups": "Grupos",
    "device": "Equipo",
    "devices": "Equipos"
  }
}
